export enum EntityScheduleType {
  VISIT = 'VISIT',
  CALENDAR = 'CALENDAR',
  EVENT = 'EVENT',
  VACATION = 'VACATION',
  REMINDER = 'REMINDER',
  CAREREMINDER = 'CAREREMINDER',
  APPOINTMENT = 'APPOINTMENT'
}

export enum EntityScheduleStatus {
  ACTIVE = 'ACTIVE',
  EXPIRED = 'EXPIRED',
  OPEN = 'OPEN',
  CLOSED = 'CLOSED',
  REQUESTED = 'REQUESTED',
  CONFIRMED = 'CONFIRMED',
  INPROGRESS = 'INPROGRESS',
  VISITED = 'VISITED'
}

export enum EntityType {
  PROVIDER = 'PROVIDER',
  PATIENT = 'PATIENT',
  CAREGIVER = 'CAREGIVER',
  CARECOORDINATOR = 'CARECOORDINATOR',
  SPECIALIST = 'SPECIALIST',
  FACILITY = 'FACILITY',
  USER = 'USER',
  INDV = 'INDV',
  NONE = 'NONE',
  ALL = 'ALL',
  OTHER = 'OTHER',
  EXTERNALAGENCY = 'EXTERNALAGENCY',
  CARETEAMPROVIDER = 'CARETEAMPROVIDER',
  HOSPITALUSER = 'HOSPITALUSER'
}

export interface Entity {
  entityType: EntityType;
  entityId: string;
}
